import { z } from "zod";
import { CompleteTaskResultSchema } from "./complete-task-payload-schema";

/**
 * Completing a whole-review Coverage QA task (lebron `qa_scope: "task"`).
 *
 * Reviewed: the final coverage result — the same shape a Coverage submission
 * sends. lebron publishes OOS events from its `out_of_stock_confirmations` and
 * diffs it against the labeler's to see what QA changed.
 */
const ReviewedResultSchema = CompleteTaskResultSchema.extend({
  status: z.literal("reviewed"),
  qa_note: z.string().optional(),
  flag_labeler: z.boolean().optional(),
});

/**
 * Rejected: nothing is published. Also the quick way out when the labels are
 * too far off to be worth fixing box by box.
 */
export const COVERAGE_QA_REJECT_REASONS = [
  { value: "unusable_image", label: "Image is unusable" },
  { value: "incorrect_task", label: "Wrong shelf / task" },
  { value: "bad_labels", label: "Labels are bad" },
  { value: "other", label: "Other" },
] as const;

const RejectedResultSchema = z.object({
  status: z.literal("rejected"),
  reason: z.enum(["unusable_image", "incorrect_task", "bad_labels", "other"]),
  qa_note: z.string().optional(),
});

export const CompleteCoverageQaEditPayloadSchema = z.object({
  result: z.union([ReviewedResultSchema, RejectedResultSchema]),
});

export type CompleteCoverageQaEditPayload = z.infer<
  typeof CompleteCoverageQaEditPayloadSchema
>;
export type CoverageQaRejectReason = z.infer<
  typeof RejectedResultSchema
>["reason"];
